import { Navigate, useParams } from 'react-router-dom'
import { WAVE_PLANS, wavePlanPath } from '@/components/WavePlanning/plans'

export default function WavePlanningLegacyRedirect({
  view,
}: {
  view: 'skus' | 'distribution-centers'
}) {
  const { calendarId, subclassId } = useParams()
  const plan = WAVE_PLANS.find(
    item => item.calendarId === calendarId && item.subclassId === subclassId
  )
  return (
    <Navigate
      to={plan ? wavePlanPath(plan.id, view) : '/wave-planning'}
      replace
    />
  )
}
